var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryVersion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.057,
    height: 16.469,
    viewBox: "0 0 23.057 16.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3729",
    "data-name": "Caminho 3729",
    d: "M12.529,3,10.882,4.647V17.823l1.647,1.647H22.41l1.647-1.647V4.647L22.41,3ZM22.41,17.823H12.529V4.647H22.41ZM7.588,12.882V6.294H9.235V4.647H6.764l-.823.823V17l.823.823h2.47V16.176H7.588ZM2.647,11.235V7.941H4.294V6.294H1.823L1,7.117v8.235l.823.823h2.47V14.529H2.647Z",
    transform: "translate(-1 -3)",
    fill: "#696969",
    stroke: "#000",
    strokeWidth: 0,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryVersion);
export default __webpack_public_path__ + "static/media/history-version.2e5c6a200a744092028ee76eb79d7487.svg";
export { ForwardRef as ReactComponent };